export default {
  title: 'Patients List',
  addPatient: 'Add patient',
};
